import { Component, Input, ViewChild, TemplateRef, ViewChildren, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

import { ItemBusquedaModel } from '../../utilidades.modelos.index';
import { UtilidadesService, LocalidadesService } from '../../utilidades.servicios.index';

import { environment } from '../../../../environments/environment';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
	selector: 'app-buscador-localidades',
	templateUrl: './buscador-localidades.component.html',
	styles: []
})
export class BuscadorLocalidadesComponent {

	constructor(
		private Utilidades: UtilidadesService,
		private Localidades: LocalidadesService
	) { }

//#region Variables Globales

	public Lista: ItemBusquedaModel[] = [];
	public OrigenDeDatos: MatTableDataSource<ItemBusquedaModel>; //Datos que necesita la tabla
	public Columnas: string[] = ['Id', 'Descripcion']; //Columna de las tablas
	@ViewChild(MatSort) Orden: MatSort; //Obtengo el paginador de la pantalla
	public TextoABuscar: string = "";
	private Ventana: MatDialogRef<any, any> = null; //Referencia del popup cuando está abierto.
	@ViewChild("PopUp") PopUp: TemplateRef<any>; //HTML que se va a mostrar en el popup.
	@ViewChildren("txtBuscar") txtBuscar;

	@Output("OnSeleccionarLocalidad") OnSeleccionarLocalidad: EventEmitter<ItemBusquedaModel> = new EventEmitter<ItemBusquedaModel>();

	@Input() ControlLocalidad: FormControl;
	@Input() LocalidadesDelPais: boolean = false; //Determina si el buscador de localidades busca localidades de la provincia o del país.

//#endregion

//#region Propiedades

	private _localidad: ItemBusquedaModel;
	get Localidad() {
		this.ActualizarCodigoLocalidad();
		return this._localidad;
	}
	set Localidad(value: ItemBusquedaModel) {
		this._localidad = value;
		this.ActualizarCodigoLocalidad();
	}

//#endregion

	ngOnInit(): void {
		if (this.ControlLocalidad) {
			this.ControlLocalidad.valueChanges.subscribe(x => {
				this.Localidades.Obtener(x, this.LocalidadesDelPais).subscribe(l => this.Localidad = l);
			});
		}
	}

//#region Porcedimientos

	ActualizarCodigoLocalidad(): void {
		if (this._localidad && this.ControlLocalidad) {
			if (this._localidad.Id != this.ControlLocalidad.value) {
				if (environment.Debug) {
					console.log(this.ControlLocalidad.value + " => " + this._localidad.Id);
				}

				this.ControlLocalidad.setValue(this._localidad.Id);
			}
		}
	}

	AbrirBuscador(): void {
		this.Localidades.Lista(this.LocalidadesDelPais).subscribe(l => {
			this.Lista = l;
			this.CargarLista(this.Lista);
			this.AbrirPopUp();
		});
	}

	CargarLista(lista: ItemBusquedaModel[]): void {
		this.OrigenDeDatos = null;

		//Creo el origen de datos con la lista del servicio
		this.OrigenDeDatos = new MatTableDataSource(lista);

		//Asigno las columnas de órden.
		this.OrigenDeDatos.sort = this.Orden;
	}

	AbrirPopUp(): void {
		this.TextoABuscar = "";
		this.Ventana = this.Utilidades.CuadroHTML(this.PopUp, "700px", "550px");
	}

	Buscar(): void {
		this.OrigenDeDatos.filter = this.TextoABuscar.toLowerCase();
	}

	Seleccionar(item): void {
		this.Localidad = item;
		this.Ventana.close();
		this.OnSeleccionarLocalidad.emit(item);
	}

//#endregion
}